import PropTypes from 'prop-types';
import React from 'react';

import ButtonList, { ButtonListItem } from '@99designs/react-components/components/ButtonList';
import IconButton from '@99designs/react-components/components/IconButton';
import Icon from '@99designs/react-components/components/Icon';

import connectToStores from 'fluxible-addons-react/connectToStores';
import DesignSketchesStore from '../../stores/DesignSketchesStore';
import { undoLastDesignPath } from '../../actions/design-sketches';

const FeedbackControls = (props, context) => (
    <div className="fullscreen-header__item--design-details">
        <ButtonList variations={['spacious']}>
            {props.canUndo && (
                <ButtonListItem>
                    <IconButton
                        onClick={props.undoLastPath}
                        variations={['lighter', 'bounce-in']}
                        title={context.intl.formatMessage({ id: 'undo_sketch' })}
                    >
                        <Icon variations={['undo-1', 'large']} />
                    </IconButton>
                </ButtonListItem>
            )}
            <ButtonListItem>
                <IconButton
                    title={context.intl.formatMessage({ id: 'sketch_feedback_mode' })}
                    onClick={() => props.toggleFeedbackMode('sketch')}
                    variations={props.feedbackMode === 'sketch' ? ['on-white'] : ['lighter']}
                >
                    <Icon variations={['sketch-1', 'large']} />
                </IconButton>
            </ButtonListItem>
            <ButtonListItem>
                <IconButton
                    title={context.intl.formatMessage({ id: 'annotate_feedback_mode' })}
                    onClick={() => props.toggleFeedbackMode('annotate')}
                    variations={props.feedbackMode === 'annotate' ? ['on-white'] : ['lighter']}
                >
                    <Icon variations={['annotate-1', 'large']} />
                </IconButton>
            </ButtonListItem>
        </ButtonList>
    </div>
);

FeedbackControls.contextTypes = {
    intl: PropTypes.object.isRequired,
};

FeedbackControls.propTypes = {
    feedbackMode: PropTypes.string.isRequired,
    toggleFeedbackMode: PropTypes.func.isRequired,
    canUndo: PropTypes.bool.isRequired,
    undoLastPath: PropTypes.func.isRequired,
};

export const ConnectedFeedbackControls = connectToStores(
    FeedbackControls,
    [DesignSketchesStore],
    (context, props) => {
        const sketchesStore = context.getStore(DesignSketchesStore);
        return {
            canUndo: sketchesStore.getPathsFromDesignSketch(props.designId).length > 0,
            undoLastPath: () =>
                context.executeAction(undoLastDesignPath, {
                    designId: props.designId,
                    csrfToken: context.csrfToken,
                }),
        };
    }
);

ConnectedFeedbackControls.contextTypes = {
    executeAction: PropTypes.func.isRequired,
    getStore: PropTypes.func.isRequired,
    csrfToken: PropTypes.string,
};

ConnectedFeedbackControls.propTypes = {
    designId: PropTypes.number.isRequired,
    feedbackMode: PropTypes.string.isRequired,
    toggleFeedbackMode: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./~/@99designs/ddo/components/Header/FeedbackControls.jsx